export class Diplomas {
    id : number;
    diplomaCode : string;
    diplomaName : string;
    displayOrder : number;
}
